import GenericTransition from '../../common/generic-transition'
import PACKAGE_COMPONENT_PREFIX from '../../common/config'

let single = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'slide-out-right', undefined, 'slideOutRight')
let group = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'group-slide-out-right', undefined, 'slideOutRight', true)

export default {single, group}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/sliding-exits/slide-out-right.js